export default __webpack_public_path__ + "static/media/bluePill.351327e7.png";